export const frontmatter = {
    "draft": true,
    "title": "API Keys",
    "description": "API key management in OnnIA.",
    "sidebar_label": "API Keys",
    "sidebar_group": "reference",
    "sidebar_order": 6
}

export const toc = []